import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.scss';
import Home from './screens/Home';
import Work from './screens/Work';
import Projects from './screens/Projects';
import Archives from './screens/Archives';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />}>
          <Route path="/" element={<Home />} />
          <Route path="/Work" element={<Work />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/archives" element={<Archives />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
